import {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {BRAND, CONTACT} from './site'
import {Listing, listingImageSrc} from '../../services/api'

// Small line-icons for the listing meta row (bed / bath / guest / pin).
const metaIcon = (path: ReactNode) => (
  <svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    {path}
  </svg>
)
const ICON_BED = metaIcon(<><path d='M2 17v-5a2 2 0 0 1 2-2h13a3 3 0 0 1 3 3v4' /><path d='M2 17h20' /><path d='M2 11V7' /></>)
const ICON_BATH = metaIcon(<><path d='M4 12h16a1 1 0 0 1 1 1v2a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-2a1 1 0 0 1 1-1z' /><path d='M6 12V5a2 2 0 0 1 2-2 2 2 0 0 1 2 2' /><path d='M6 19v1M18 19v1' /></>)
const ICON_PIN = metaIcon(<><path d='M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z' /><circle cx='12' cy='10' r='3' /></>)

/**
 * Property-listing card for an accommodation — image with a price overlay,
 * title, address, and a beds/baths/guests meta row. Links to the listing
 * detail page. Shared by the Home and Rooms pages.
 */
export const RoomCard = ({a}: {a: Listing}) => (
  <Link to={`/rooms/${a.slug}`} style={{textDecoration: 'none', display: 'block', height: '100%'}}>
    <div
      className='ccp-lift'
      style={{
        background: '#fff',
        borderRadius: 16,
        overflow: 'hidden',
        height: '100%',
        border: '1px solid #eef0f4',
        boxShadow: '0 10px 30px rgba(27,27,41,0.06)',
      }}
    >
      <div className='ccp-zoom' style={{position: 'relative', overflow: 'hidden'}}>
        <img src={listingImageSrc(a.gallery[0])} alt={a.title} loading='lazy' style={{width: '100%', height: 300, objectFit: 'cover', display: 'block'}} />
        <div style={{position: 'absolute', inset: 0, background: 'linear-gradient(transparent 55%, rgba(0,0,0,0.55))'}} />
        <div style={{position: 'absolute', left: 22, bottom: 18, color: '#fff', display: 'flex', alignItems: 'baseline', gap: 4}}>
          <span style={{fontSize: 34, fontWeight: 800, lineHeight: 1, textShadow: '0 2px 8px rgba(0,0,0,0.4)'}}>{a.fromPrice ? `$${Number(a.fromPrice).toFixed(0)}` : a.price}</span>
          <span style={{fontSize: 15, fontWeight: 600, opacity: 0.95}}>/month</span>
        </div>
      </div>

      <div style={{padding: '22px 24px 26px'}}>
        <h3 style={{fontSize: 21, fontWeight: 700, color: BRAND.ink, margin: '0 0 8px'}}>{a.title}</h3>
        <div style={{display: 'flex', alignItems: 'center', gap: 7, color: BRAND.muted, fontSize: 14, marginBottom: 18}}>
          <span style={{color: '#aab0bf', display: 'inline-flex'}}>{ICON_PIN}</span>
          {CONTACT.publicLocation}
        </div>

        <div style={{display: 'flex', flexWrap: 'wrap', gap: 22, paddingTop: 16, borderTop: '1px solid #f1f3f7', color: BRAND.ink}}>
          {[
            {icon: ICON_BED, text: a.beds},
            {icon: ICON_BATH, text: a.baths},
          ].map((m, i) => (
            <span key={i} style={{display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 500}}>
              <span style={{color: BRAND.green, display: 'inline-flex'}}>{m.icon}</span>
              {m.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  </Link>
)
